export default __webpack_public_path__ + "static/media/0028.a272d4b2.WAV";